module.exports = __webpack_public_path__ + "static/media/shutterstock_1124255354.153933ca.jpg";